export default __webpack_public_path__ + "static/media/mapa_pszczoly.86f53a82.png";